import GenerateCodeSetFaucet from './GenerateCodeSetFaucet'

export default GenerateCodeSetFaucet
